// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"27138d40","157":"29a72579","237":"ae14d678","264":"186bf5d0","283":"4a868090","322":"b7bf4900","384":"64aa494f","609":"887c43d0","638":"d2e039e5"}[chunkId] + ".chunk.js";
};